import "../style.css";
import { useEffect, useState } from "react";
import axios from "axios";

function FilterMenu({ onApplyFilter, reset }) {
    const [filters, setFilters] = useState({
        country: "",
        state: "",
        category: "",
        majorLithology: "",
        discipline: "",
        rockType: "",
        formation: "",
        age: ""
    });

    const [rockType, setRockType] = useState([]);
    const [majorLithology, setMajorLithology] = useState([]);
    const [formation, setFormation] = useState([]);
    const [age, setAge] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const rockTypeResponse = await axios.get('https://geoid-rest.vercel.app/typeOfRock');
            const majorLithologyResponse = await axios.get('https://geoid-rest.vercel.app/majorLithology');
            const formationResponse = await axios.get('https://geoid-rest.vercel.app/formation');
            const ageResponse = await axios.get('https://geoid-rest.vercel.app/ageCategory');
            setRockType(rockTypeResponse.data);
            setMajorLithology(majorLithologyResponse.data);
            setFormation(formationResponse.data);
            setAge(ageResponse.data);
        }

        fetchData();
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prevFilters => ({
            ...prevFilters,
            [name]: value
        }));

        // Reset geology-related filters when category changes
        if (name === 'category' && value !== 'geology') {
            setFilters(prevFilters => ({
                ...prevFilters,
                majorLithology: "",
                discipline: "",
                rockType: "",
                formation: "",
                age: ""
            }));
        }
    };

    const handleApply = () => {
        onApplyFilter(filters);
    };

    const handleReset = () => {
        setFilters({
            country: "",
            state: "",
            category: "",
            majorLithology: "",
            discipline: "",
            rockType: "",
            formation: "",
            age: ""
        });
        reset();
    };

    return (
        <div
            style={{
                position: "absolute",
                top: "4rem",
                left: "0",
                background: "white",
                padding: "10px 15px",
                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                zIndex: 500,
            }}
        >
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                <div style={{display: 'flex', gap: '10px' }}>
                    <label>
                        <select
                            name="country"
                            className="dropdown"
                            value={filters.country}
                            onChange={handleChange}
                        >
                            <option value="">Country</option>
                            <option value="Malaysia">Malaysia</option>
                        </select>
                    </label>

                    <label>
                        <select
                            name="state"
                            className="dropdown"
                            value={filters.state}
                            onChange={handleChange}
                        >
                            <option value="">State</option>
                            <option value="terengganu">Terengganu</option>
                            <option value="kedah">Kedah</option>
                            <option value="johor">Johor</option>
                            <option value="kelantan">Kelantan</option>
                            <option value="malacca">Malacca</option>
                            <option value="negeri-sembilan">Negeri Sembilan</option>
                            <option value="pahang">Pahang</option>
                            <option value="penang">Penang</option>
                            <option value="perak">Perak</option>
                            <option value="perlis">Perlis</option>
                            <option value="sabah">Sabah</option>
                            <option value="sarawak">Sarawak</option>
                            <option value="selangor">Selangor</option>
                            <option value="kuala-lumpur">Kuala Lumpur</option>
                            <option value="labuan">Labuan</option>
                            <option value="putrajaya">Putrajaya</option>
                        </select>
                    </label>

                    <label>
                        <select
                            name="category"
                            className="dropdown"
                            value={filters.category}
                            onChange={handleChange}
                        >
                            <option value="">Category</option>
                            <option value="geology">Geology</option>
                            <option value="archaeology">Archaeology</option>
                        </select>
                    </label>

                    {filters.category === "geology" && (
                        <>
                            <label>
                                <select 
                                    name="rockType" 
                                    className="dropdown" 
                                    value={filters.rockType} 
                                    onChange={handleChange}
                                >
                                    <option value="">Type of Rock</option>
                                    {rockType.map((rock) => (
                                        <option key={rock._id} value={rock.data.toLowerCase()}>
                                            {rock.data.toUpperCase()}
                                        </option>
                                    ))}
                                </select>
                            </label>

                            <label>
                                <select 
                                    name="majorLithology" 
                                    className="dropdown" 
                                    value={filters.majorLithology} 
                                    onChange={handleChange}
                                >
                                    <option value="">Major Lithology</option>
                                    {majorLithology.map((major) => (
                                        <option key={major._id} value={major.data.toLowerCase()}>
                                            {major.data.toUpperCase()}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </>
                    )}
                </div>

                <div style={{display: 'flex', gap: '10px' }}>
                    <div className="reset-button" onClick={handleReset}>
                        <button>Reset Search & Filter</button>
                    </div>
                    <div className="apply-button" style={{color: "#b5205e !important" }}>
                        <button onClick={handleApply}>Apply Filter</button>
                    </div>


                    {filters.category === "geology" && (
                        <>
                             <div>
                                <label>
                                    <select 
                                        name="discipline" 
                                        className="dropdown" 
                                        value={filters.discipline} 
                                        onChange={handleChange}
                                    >
                                        <option value="">Disciplines</option>
                                        <option value="gAll">Geology - all</option>
                                        <option value="gGeneral">Geology - general</option>
                                        <option value="gONG">Geology - oil & gas</option>
                                        <option value="gMining">Geology - mining</option>
                                        <option value="gEngineering">Geology - engineering/geotechnical</option>
                                        <option value="gEnvironment">Geology - environment</option>
                                    </select>
                                </label>
                            </div>

                            <div>
                                <label>
                                    <select 
                                        name="formation" 
                                        className="dropdown" 
                                        value={filters.formation} 
                                        onChange={handleChange}
                                    >
                                    <option value="">Formation</option>
                                    {formation.map((formation) => (
                                        <option key={formation._id} value={formation.data.toLowerCase()}>
                                            {formation.data.toUpperCase()}
                                        </option>
                                    ))}
                                    </select>
                                </label>
                            </div>

                            <div>
                                <label>
                                    <select 
                                        name="age" 
                                        className="dropdown" 
                                        value={filters.age} 
                                        onChange={handleChange}
                                    >
                                    <option value="">Age</option>
                                    {age.map((age) => (
                                        <option key={age._id} value={age.data.toLowerCase()}>
                                            {age.data.toUpperCase()}
                                        </option>
                                    ))}
                                    </select>
                                </label>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default FilterMenu;